/**
 *
 * Button
 *
 */

import React from 'react';
import { Button as CustomButton } from 'antd';

import Icon from '../Icon';
import Text from '../Text';
import './style.css';

// eslint-disable-next-line sonarjs/cognitive-complexity
function Button({
  text,
  type = 'normal',
  icon,
  iconSize,
  iconColor,
  useAntd = false,
  disabled = false,
  loading,
  ...rest
}: any) {
  const style = {
    height: rest.height || '32px',
    lineHeight: rest.height || '32px',
    width: rest.width || '100%',
  };

  if (type === 'circle') {
    return (
      <CustomButton
        {...rest}
        className="circleButton"
        disabled={disabled}
        loading={loading}
        style={style}
      >
        {icon && (
          <Icon
            useAntd={useAntd}
            size={iconSize || 16}
            type={icon}
            color={iconColor}
          />
        )}
      </CustomButton>
    );
  }

  const getClassName = () => {
    if (type === 'circle') return 'circleButton';
    return `${'custom-btn'} ${`ant-btn-${type}`} ${
      rest.className ? rest.className : ''
    } ${disabled ? 'disabledStyles' : ''}`;
  };

  const getIconStyles = () => {
    if (type === 'circle') return {};
    return { marginRight: text ? 5 : 0, color: iconColor || null };
  };

  return (
    <CustomButton
      {...rest}
      className={getClassName()}
      disabled={disabled}
      loading={loading}
      style={style}
    >
      {icon && (
        <Icon
          useAntd={useAntd}
          size={iconSize || 16}
          type={icon}
          style={getIconStyles()}
          color={iconColor}
          {...rest}
        />
      )}
      {text ? (
        <Text
          text={text}
          style={{ textTransform: rest.texttransform || 'none' }}
        />
      ) : (
        rest.children
      )}
    </CustomButton>
  );
}

export default Button;
